let apiKey = `bfec4eebc4a43c1fa17030fee2436234`;

let now = new Date();
let hour = now.getHours();
let minutes = now.getMinutes();
if (hour < 10) {
  hour = `0${hour}`;
}
if (minutes < 10) {
  minutes = `0${minutes}`;
}
let date = now.getDate();
let months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
let month = months[now.getMonth()];
let weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
let weekDay = weekDays[now.getDay()];
let dateTime = document.querySelector("#date-time");
dateTime.innerHTML = `${weekDay}, ${month} ${date} ${hour}:${minutes}`;

function formatDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
  return days[day];
}

function displayForecast(response) {
  let forecastElement = document.querySelector(".forecast");
  let forecast = response.data.daily;

  forecastHTML = `<div class="row">`;
  forecast.forEach(function (forecastDay, index) {
    if (index < 6) {
      forecastHTML =
        forecastHTML +
        `<div class="col-2">
      <div class="card">
                <div class="card-body">
                  <i class="weekday1">${formatDay(forecastDay.dt)}</i>
                  <br />
                  <img
                    src="http://openweathermap.org/img/wn/${
                      forecastDay.weather[0].icon
                    }@2x.png"
                    class="forecast-icon"
                    alt="weather"
                  />
                  <br />
                  <h6 class="fa-solid fa-temperature-arrow-up max1">${Math.round(
                    forecastDay.temp.max
                  )}ºC</h6>
                  <h6 class="fa-solid fa-temperature-arrow-down min1">${Math.round(
                    forecastDay.temp.min
                  )}ºC</h6>
                </div>
                </div>
                </div>
              `;
    }
  });
  forecastHTML = forecastHTML + `</div>`;
  forecastElement.innerHTML = forecastHTML;
}
function getForecast(coordinates) {
  let forecastApiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apiKey}&units=metric`;
  axios.get(forecastApiUrl).then(displayForecast);
}

function currentLocation(event) {
  function getCurLocTemp(response) {
    let temperature = Math.round(response.data.main.temp);
    maxTempQuery.innerHTML = `${Math.round(response.data.main.temp_max)}ºC`;
    minTempQuery.innerHTML = `${Math.round(response.data.main.temp_min)}ºC`;
    feelsLikeQuery.innerHTML = `Feels like:${Math.round(
      response.data.main.feels_like
    )}ºC`;
    windQuery.innerHTML = `Wind:${Math.round(response.data.wind.speed)}km/h`;
    humidityQuery.innerHTML = `Humidity:${Math.round(
      response.data.main.humidity
    )}%`;
    descriptionQuery.innerHTML = `${response.data.weather[0].description}`;
    currentWeatherQuery.innerHTML = `${temperature}ºC`;
    cityNameQuery.innerHTML = `${response.data.name}`;
    iconQuery.setAttribute(
      "src",
      `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
    );
    iconQuery.setAttribute("alt", response.data.weather[0].description);

    getForecast(response.data.coord);
    function tempChange(event) {
      event.preventDefault();
      let currentTemp = document.querySelector(".current-weather");
      if (temperatureChange.innerHTML === "ºF") {
        let fahrenheit = Math.round(temperature * 1.8 + 32);
        let fahrenheitFeelsLike = Math.round(
          response.data.main.feels_like * 1.8 + 32
        );
        let fahrenheitMaxTemp = Math.round(
          response.data.main.temp_max * 1.8 + 32
        );
        let fahrenheitMinTemp = Math.round(
          response.data.main.temp_min * 1.8 + 32
        );
        temperatureChange.innerHTML = "ºC";
        currentTemp.innerHTML = `${fahrenheit}ºF`;
        feelsLikeQuery.innerHTML = `Feels like ${fahrenheitFeelsLike}ºF`;
        maxTempQuery.innerHTML = `${fahrenheitMaxTemp}ºF`;
        minTempQuery.innerHTML = `${fahrenheitMinTemp}ºF`;
      } else {
        temperatureChange.innerHTML = "ºF";
        currentTemp.innerHTML = `${temperature}ºC`;
        maxTempQuery.innerHTML = `${Math.round(response.data.main.temp_max)}ºC`;
        minTempQuery.innerHTML = `${Math.round(response.data.main.temp_min)}ºC`;
        feelsLikeQuery.innerHTML = `Feels like:${Math.round(
          response.data.main.feels_like
        )}ºC`;
      }
    }
    let temperatureChange = document.querySelector(".change-unit-btn");
    temperatureChange.addEventListener("click", tempChange);
  }
  function showLocation(position) {
    let latitude = position.coords.latitude;
    let longitude = position.coords.longitude;
    let coordUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=${apiKey}`;
    axios.get(coordUrl).then(getCurLocTemp);
  }
  navigator.geolocation.getCurrentPosition(showLocation);

  function searchCity(event) {
    event.preventDefault();
    let cityResult = document.querySelector(".search-text");
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${cityResult.value}&units=metric&appid=${apiKey}`;
    function getSearchTemp(response) {
      temperature = Math.round(response.data.main.temp);
      maxTempQuery.innerHTML = `${Math.round(response.data.main.temp_max)}ºC`;
      minTempQuery.innerHTML = `${Math.round(response.data.main.temp_min)}ºC`;
      feelsLikeQuery.innerHTML = `Feels like:${Math.round(
        response.data.main.feels_like
      )}ºC`;
      windQuery.innerHTML = `Wind: ${Math.round(response.data.wind.speed)}m/s`;
      humidityQuery.innerHTML = `Humidity: ${Math.round(
        response.data.main.humidity
      )}%`;
      descriptionQuery.innerHTML = `${response.data.weather[0].description}`;
      currentWeatherQuery.innerHTML = `${temperature}ºC`;
      cityNameQuery.innerHTML = `${response.data.name}`;
      iconQuery.setAttribute(
        "src",
        `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`
      );
      iconQuery.setAttribute("alt", response.data.weather[0].description);

      getForecast(response.data.coord);

      function searchTempChange(event) {
        event.preventDefault();
        if (searchTemperatureChange.innerHTML === "ºF") {
          let fahrenheit = Math.round(temperature * 1.8 + 32);
          let fahrenheitFeelsLike = Math.round(
            response.data.main.feels_like * 1.8 + 32
          );
          let fahrenheitMaxTemp = Math.round(
            response.data.main.temp_max * 1.8 + 32
          );
          let fahrenheitMinTemp = Math.round(
            response.data.main.temp_min * 1.8 + 32
          );
          searchTemperatureChange.innerHTML = "ºC";
          currentWeatherQuery.innerHTML = `${fahrenheit}ºF`;
          feelsLikeQuery.innerHTML = `Feels like ${fahrenheitFeelsLike}ºF`;
          maxTempQuery.innerHTML = `${fahrenheitMaxTemp}ºF`;
          minTempQuery.innerHTML = `${fahrenheitMinTemp}ºF`;
        } else {
          searchTemperatureChange.innerHTML = "ºF";
          currentWeatherQuery.innerHTML = `${temperature}ºC`;
          maxTempQuery.innerHTML = `${Math.round(
            response.data.main.temp_max
          )}ºC`;
          minTempQuery.innerHTML = `${Math.round(
            response.data.main.temp_min
          )}ºC`;
          feelsLikeQuery.innerHTML = `Feels like:${Math.round(
            response.data.main.feels_like
          )}ºC`;
        }
      }
      let searchTemperatureChange = document.querySelector(".change-unit-btn");
      searchTemperatureChange.addEventListener("click", searchTempChange);
    }
    axios.get(apiUrl).then(getSearchTemp);
  }
  let searchForm = document.querySelector(".search-form");
  searchForm.addEventListener("submit", searchCity);
}
addEventListener("load", currentLocation);

let temperature = null;
let cityNameQuery = document.querySelector(".city-name");
let currentWeatherQuery = document.querySelector(".current-weather");
let descriptionQuery = document.querySelector(".weather-description");
let humidityQuery = document.querySelector(".humidity");
let windQuery = document.querySelector(".wind");
let feelsLikeQuery = document.querySelector(".feels-like");
let maxTempQuery = document.querySelector(".maxtemp");
let minTempQuery = document.querySelector(".mintemp");
let iconQuery = document.querySelector(".weather-icon");
